module.exports = __webpack_public_path__ + "img/operative_one-dark-bkgd@2x.7676ecc9.png";